import { BaseResponseInterface } from '@interface/public';
import { AxiosAPI } from '@server/_axios';

const apiPath = { // API地址
  activity: 'activity/' // 活动
};

//----- 获取微信授权 Start -----//
export interface RequestWeChatAuth {
  app: '' | 'mp_e35' | 'mini_7e7'; // 应用
  url: string; // 当前网址
}

export interface ResponseWeChatAuth extends BaseResponseInterface {
  data: {
    app_id: string; // 公众号标识
    timestamp: number; // 生成签名的时间戳
    nonce_str: string; // 生成签名的随机串
    signature: string; // 签名
  };
}

export async function AxiosWeChatAuth(params: RequestWeChatAuth): Promise<any> {
  return AxiosAPI({
    url: `${ apiPath.activity }wechat/jsconfig`,
    params: {
      ...params,
      t: Date.now()
    }
  });
}

//----- 获取微信授权 End -----//